import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createCarousel } from './Carousel';
import { CAROUSEL_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(CAROUSEL_BASE_CLASSNAME), createCarousel, NO_PATTERN_BUSINESS_LOGIC);
